import { useEffect, useState, useRef } from 'react'

export function useResponsiveContainer(
  callback: ({ width, height }: { width: number; height: number }) => void
) {
  const containerRef = useRef<any>(null!)
  const dataRef = useRef<any>(null!)

  if (typeof window === 'undefined') {
    return null
  }

  const { MutationObserver } = window

  useEffect(() => {
    const elements = containerRef.current
    const observer = new MutationObserver(mutationList => {
      const width = window.getComputedStyle(elements).getPropertyValue('width')
      const height = window
        .getComputedStyle(elements)
        .getPropertyValue('height')
      if (
        width === dataRef?.current?.width &&
        height === dataRef?.current?.height
      )
        return
      dataRef.current = {
        width: Number(width.replace('px', '')),
        height: Number(height.replace('px', '')),
        innerWidth: window.innerWidth,
      }
      callback(dataRef.current)
    })
    observer.observe(containerRef.current, {
      childList: true, // 子节点的变动（新增、删除或者更改）
      attributes: true, // 属性的变动
      characterData: true, // 节点内容或节点文本的变动
      subtree: true, // 是否将观察器应用于该节点的所有后代节点
    })

    return () => {
      if (observer) {
        observer.disconnect()
        observer.takeRecords()
      }
    }
  }, [containerRef.current, callback])

  return containerRef
}
